import { render, staticRenderFns } from "./u-gnb-basic.vue?vue&type=template&id=2c27d324&scoped=true&"
import script from "./u-gnb-basic.vue?vue&type=script&lang=js&"
export * from "./u-gnb-basic.vue?vue&type=script&lang=js&"
import style0 from "./u-gnb-basic.vue?vue&type=style&index=0&id=2c27d324&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c27d324",
  null
  
)

export default component.exports